const upOrDown = (num: number | null) => {
    if (!num) return '';

    return num > 0 ? 'up ' : 'down ';
};

export default upOrDown;
